import { RootState } from 'src/store';

import { IProviderSettingsListData } from './types';

export const selectProviderSettingsData = (state: RootState): Partial<IProviderSettingsListData> => state.providersSettings.data;
export const selectProviderSettingsLoading = (state: RootState): boolean => state.providersSettings.isLoading;
export const selectProviderSettingsLoaded = (state: RootState): boolean => state.providersSettings.isLoaded;
